import { useMediaQuery } from '@mui/material'
import Box from '@mui/material/Box'
import React, { useState } from 'react'
import { isDesktop } from 'react-device-detect'
import { Else, If, Then, When } from 'react-if'

import { navigateToMapPage } from '../../Scenes/navigators'
import { BREAKPOINT_MIN_XL } from '../../Theme/stylesUtil'
import { getPlaceTrophyIconName } from '../ContestComponents/PrizeCard/constants'
import { MapCard } from './CollectionCard/MapCard'
import TrophyIcon from './TrophyIcon'

const UserCardMapImage = ({ mapCard, length, index, mapHeight = 48, isWithPopper = true }) => {
  const [openPopper, setOpenPopper] = useState(false)
  const isBiggerThanXLScreen = useMediaQuery(BREAKPOINT_MIN_XL)
  const isLastElem = length === index + 1 && !isBiggerThanXLScreen
  const trophySize = !isWithPopper ? '32px' : '24px'
  return (
    <Box sx={{ position: 'relative' }}>
      <If condition={isWithPopper}>
        <Then>
          <Box
            component="img"
            sx={{
              display: 'block',
              width: '100%',
              height: '48px',
              objectFit: 'cover',
              overflow: 'hidden',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
            src={mapCard.map_images?.[0].urls?.medium}
            onMouseEnter={() => setOpenPopper(true)}
            onMouseLeave={() => setOpenPopper(false)}
            onClick={() => navigateToMapPage(mapCard.id)}
          />
        </Then>
        <Else>
          <Box
            sx={{
              display: 'block',
              width: '100%',
              objectFit: 'cover',
              overflow: 'hidden',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
            onMouseEnter={() => setOpenPopper(true)}
            onMouseLeave={() => setOpenPopper(false)}
          >
            <MapCard
              map={mapCard}
              style={{ height: `${mapHeight}px` }}
              isShowUser={!isWithPopper}
            />
          </Box>
        </Else>
      </If>

      <TrophyIcon
        place={getPlaceTrophyIconName(index + 1)}
        withNumberInGoblet={true}
        number={index + 1}
        containerStyles={{
          position: 'absolute',
          top: '3px',
          left: '3px',
          width: trophySize,
          height: trophySize,
          borderRadius: '8px',
        }}
        size={!isWithPopper ? 40 : 30}
        withBackground={true}
        withBackgroundWithoutText={true}
        fontSize={!isWithPopper ? 14 : 10}
      />
      <When condition={openPopper && isDesktop && isWithPopper}>
        <Box sx={{ position: 'absolute', top: '-150px', left: isLastElem ? '-100px' : '-50px' }}>
          <Box sx={{ position: 'relative' }} />

          <Box
            component="img"
            sx={{
              display: 'block',
              width: '200px',
              height: '135px',
              objectFit: 'cover',
              overflow: 'hidden',
              borderRadius: '8px',
            }}
            src={mapCard.map_images?.[0].urls?.medium}
          />
          <TrophyIcon
            place={getPlaceTrophyIconName(index + 1)}
            withNumberInGoblet={true}
            number={index + 1}
            containerStyles={{
              position: 'absolute',
              top: '10px',
              left: '10px',
              width: '40px',
              height: '40px',
              borderRadius: '8px',
            }}
            size={30}
            withBackground={true}
            withBackgroundWithoutText={true}
          />
        </Box>
      </When>
    </Box>
  )
}

export default UserCardMapImage
